import React from "react";
import ReactDOM from "react-dom/client";
import "@fontsource-variable/inter";
import "./index.css";

import { Provider } from 'react-redux'
import store from './store'
import setupInterceptors from "./services/setupInterceptors";

import App from "./App";
import { BrowserRouter } from "react-router-dom";
import ErrorBoundary from "./components/global/ErrorBoundary";


const root = ReactDOM.createRoot(document.getElementById("root"));

root.render(
  <Provider store={store}>
    {/* <React.StrictMode> */}
      <BrowserRouter>
        <ErrorBoundary>
          <App />
        </ErrorBoundary>
      </BrowserRouter>
    {/* </React.StrictMode> */}
  </Provider>
);

setupInterceptors(store);
